import { render, staticRenderFns } from "./insMenu.vue?vue&type=template&id=14b6bc73&"
import script from "./insMenu.vue?vue&type=script&lang=js&"
export * from "./insMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports